module.exports = __webpack_public_path__ + "static/step_01.280f9e87.png";